import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { useTrendEntity } from 'src/utils/Hooks/reduxSelectors';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

const TrendEntitySummary = () => {
  const { trendEntity } = useTrendEntity();
  const textStyles = {
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.08px'
  };

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={32}>
        <Flex flexDirection="column" gap={8}>
          <Text>
            <Text
              variant="h4"
              sx={{
                lineHeight: '28px',
                letterSpacing: '0.08px'
              }}
            >
              Microtrend Details
            </Text>
            <Text
              variant="body2"
              fontWeight="400"
              sx={{
                marginTop: '8px',
                lineHeight: '20px',
                letterSpacing: '0.08px'
              }}
            >
              {trendEntity?.subcategoryName}
            </Text>
          </Text>

          <Flex marginTop="24px">
            <Flex width="151px">
              <Text variant="body2" sx={{ fontWeight: 700 }}>
                Microtrend Name
              </Text>
            </Flex>
            <Flex marginLeft="32px">
              <Text variant="body2" sx={textStyles}>
                {trendEntity?.displayName}
              </Text>
            </Flex>
          </Flex>

          <Flex marginTop="16px">
            <Flex width="151px">
              <Text variant="body2" sx={{ fontWeight: 700, width: '151px' }}>
                Microtrend Description
              </Text>
            </Flex>
            <Flex marginLeft="32px">
              <Text variant="body2" sx={textStyles}>
                {trendEntity.summary}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </BasePageContainer>
  );
};

export default TrendEntitySummary;
